export default __webpack_public_path__ + "static/media/img-0369-ovato-nation-full-face.f4e5d4fc.png";